import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthProvider } from './auth/auth-provider';
import { AuthBridge } from './auth/auth-bridge';
import { queryClient } from './lib/query-client';
import { WsEventBridge } from './lib/ws/ws-event-bridge';
import { router } from './routes';
import { RouteErrorFallback } from './components/error-boundary';
import { ScreenLock } from './components/screen-lock/screen-lock';

export function App() {
  return (
    <ErrorBoundary FallbackComponent={RouteErrorFallback}>
      <AuthProvider>
        <AuthBridge />
        <QueryClientProvider client={queryClient}>
          <WsEventBridge />
          <RouterProvider router={router} />
        </QueryClientProvider>
        <ScreenLock />
      </AuthProvider>
    </ErrorBoundary>
  );
}
